
































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Form } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import md5 from 'js-md5'
import request from '@/utils/request'
  @Component({
    name: 'ClientLogin'
  })

export default class extends Vue {
  private imageLogo:any = require('@/assets/logo.png')
  private loginBannerImages:any = [
    require('@/assets/images/login/banner1.jpg'),
    require('@/assets/images/login/banner2.jpg'),
    require('@/assets/images/login/banner3.jpg')
  ]
  private verifyCode:any = {}
  private verifyCodeImage:any=''
  private sendPhoneCodeText:any = '发送验证码'
  private sendPhoneCodeFlag:any = true
  private sendPhoneCodeTime:any = 0
  private loginCodeBtnText:any = '发送验证码'
  private loginCodeBtnFlag:any = true
  private loginCodeBtnTime:any = 0
  private buttonData:any = {
    disabled: false,
    loadding: false,
    text: '登　　录'
  }
  private loginInfo:any = {
    identity: '',
    image: '',
    account: '',
    accountText: '手机号',
    password: '',
    passwordText: '密　码',
    code: '',
    codeText: '验证码'
  }
  private passWordInfo:any = {
    phone: '',
    passWord: '',
    confirmPassWord: '',
    verificationCode: ''
  }
  private dialogData:any = {
    showResetPassWordForm: false
  }
  // 步骤1数据
  private step1FormInfo: any = {
    phone: '',
    pictureCodeIdentity: '',
    pictureCode: '',
    phoneCodeIdentity: '',
    phoneCode: '',
    registerIdentity: ''
  }
  private validateLoginInfo:any = {
    account: [
      { required: true, message: '请输入手机号', trigger: 'blur' }
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' }
    ],
    code: [
      { required: true, message: '请输入验证码', trigger: 'blur' }
    ]
  }
  // 重置密码验证
  private resetPassWordVerify = {
    phone: [
      { required: true, message: '手机号不能为空', trigger: 'blur' },
      { validator: this.validatePhone, trigger: 'blur' }
    ],
    passWord: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      { min: 8, max: 16, message: '密码长度在8~16之间', trigger: 'blur' },
      { validator: this.validatePassWord, trigger: 'blur' }
    ],
    confirmPassWord: [
      { required: true, message: '确认密码不能为空', trigger: 'blur' },
      { validator: this.validateConfirmPassWord, trigger: 'blur' }
    ],
    verificationCode: [
      { required: true, message: '验证码不能为空', trigger: 'blur' }
    ]
  }
  // 验证密码
  private validatePassWord(rule: any, value: any, callback: Function) {
    var _chinese = new RegExp(/[\u4e00-\u9fa5]/)
    var _password = new RegExp(/^(?:(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*))[0-9A-Za-z`~!@#\\$%\\^&*\\(\\)\\-_=\\+\\[\\{\\}\\|;:'",.<>\\/\\?]{8,16}$/)
    if (_chinese.test(value)) {
      callback(new Error('密码中不能包含汉字'))
    } else if (!_password.test(value)) {
      callback(new Error('密码必须包含大写英文、小写字母和数字'))
    } else if (value === this.passWordInfo.userName) {
      callback(new Error('密码不能与账号相同'))
    } else {
      callback()
    }
  }
  // 验证确认密码
  private validateConfirmPassWord(rule:any, value: any, callback: Function) {
    if (value !== this.passWordInfo.passWord) {
      callback(new Error('两次输入密码不一致!'))
    } else {
      callback()
    }
  }
  // 验证手机号
  private validatePhone(rule: any, value: any, callback: Function) {
    var _rule = new RegExp(/^(13[0-9]{1}|14[5.7,9]|15[0,1,2,3,5,6,7,8,9]{1}|166|17[1,2,3,5,6,7,8]{1}|18[0-9]{1}|19[1,5,7,8,9]{1})[0-9]{8}$/)
    if (!_rule.test(value)) {
      callback(new Error('手机号格式错误'))
    }
  }
  // 关闭重置密码表单
  private closeResetPassWordForm() {
    this.dialogData.showResetPassWordForm = false
    this.resetValidate('passWordInfo')
    this.passWordInfo = {
      identity: '',
      image: '',
      userId: '',
      userName: '',
      passWord: '',
      confirmPassWord: '',
      verificationCode: ''
    }
    console.log(this.passWordInfo)
  }
  // 重置验证信息
  private resetValidate(formName: any) {
    (this.$refs[formName] as Form).resetFields()
  }
  // 获取验证码凭证
  private getVerificationCodeIdentity(callback: Function) {
    request({
      url: '/VerifyCode/CreateIdentity',
      method: 'GET',
      params: { codeType: 2 }
    }).then((response:any) => {
      if (response.code === 200) {
        this.verifyCode.identity = response.data[0]
        callback()
      } else {
        this.message(response.code, response.msg)
      }
    }).catch((response:any) => {
      this.message(500, response)
    })
  }
  // 获取验证码凭证
  private getCodeIdentity(callback: Function) {
    request({
      url: '/VerifyCode/CreateIdentity',
      method: 'GET',
      params: { codeType: 2 }
    }).then((response:any) => {
      if (response.code === 200) {
        this.passWordInfo.phoneCodeIdentity = response.data[0]
        console.log(this.passWordInfo.phoneCodeIdentity)
        callback()
      } else {
        this.message(response.code, response.msg)
      }
    }).catch((response:any) => {
      this.message(500, response)
    })
  }
  // 发送手机验证码
  private sendPhoneCode() {
    request({
      url: '/Register/IfPhoneHave',
      method: 'GET',
      params: { phone: this.passWordInfo.phone }
    }).then((have:any) => {
      if (have.code === 200) {
        console.log(this.sendPhoneCodeTime)
        if (this.sendPhoneCodeFlag && this.sendPhoneCodeTime === 0) {
          var _validate = '';
          (this.$refs['passWordInfo'] as Form).validateField('phone', (error) => {
            _validate += error
            console.log(error)
          })
          if (_validate === '') {
            let _this = this
            _this.sendPhoneCodeFlag = false
            request({
              url: '/VerifyCode/SendPhoneCode',
              method: 'GET',
              params: {
                phone: this.passWordInfo.phone,
                identity: this.passWordInfo.phoneCodeIdentity
              }
            }).then((response:any) => {
              if (response.code === 200) {
                this.step1FormInfo.phoneCodeIdentity = response.info
                _this.sendPhoneCodeTime = 60
                let interval = window.setInterval(function() {
                  _this.sendPhoneCodeText = _this.sendPhoneCodeTime + '秒后重新发送'
                  _this.sendPhoneCodeTime--
                  if (_this.sendPhoneCodeTime === 0) {
                    _this.sendPhoneCodeText = '发送验证码'
                    _this.sendPhoneCodeFlag = true
                    window.clearInterval(interval)
                  }
                }, 1000)
              } else {
                _this.sendPhoneCodeFlag = true
              }
              this.message(response.code, response.msg)
            }).catch((response:any) => {
              this.message(500, response)
            })
          }
        }
      } else {
        this.$message({
          type: 'warning',
          message: have.msg
        })
      }
    }).catch((have:any) => {
      this.message(500, have)
    })
  }
   private getVerificationCode() {
    if (this.loginInfo.account === '') {
      this.message(500, '请输入手机号')
      return
    }
    if (!this.loginCodeBtnFlag || this.loginCodeBtnTime > 0) {
      return
    }
    let _this = this
    _this.loginCodeBtnFlag = false
    this.getVerificationCodeIdentity(() => {
      request({
      url: '/VerifyCode/SendPhoneCode',
      method: 'GET',
      params: {
        phone: this.loginInfo.account,
        identity: this.verifyCode.identity
      }
    }).then((response:any) => {
      if (response.code === 200) {
        _this.loginCodeBtnTime = 60
        let interval = window.setInterval(function() {
          _this.loginCodeBtnText = _this.loginCodeBtnTime + '秒后重新发送'
          _this.loginCodeBtnTime--
          if (_this.loginCodeBtnTime === 0) {
            _this.loginCodeBtnText = '获取手机验证码'
            _this.loginCodeBtnFlag = true
            window.clearInterval(interval)
          }
        }, 1000)
        this.message(response.code, response.msg)
      } else {
        _this.loginCodeBtnFlag = true
        this.message(response.code, response.msg)
      }
    }).catch((response:any) => {
      _this.loginCodeBtnFlag = true
      this.message(500, response)
    })
    })
    
   }
  private download() {
    window.open('https://jkyxht.qoct.cn:8057/%E4%B8%9C%E6%B8%AF%E5%9C%A8%E7%BA%BF%E6%8A%BC%E7%AE%B1%E5%B9%B3%E5%8F%B0%E6%B3%A8%E5%86%8C%E6%B5%81%E7%A8%8B.docx')
  }

  // 获取图片验证码
  private getVerificationCodeImage() {
    request({
      url: '/VerifyCode/CreatePictureCode',
      method: 'GET',
      params: { identity: this.verifyCode.identity }
    }).then((response:any) => {
      if (response.code === 200) {
        this.verifyCodeImage = response.info
      } else {
        this.message(response.code, response.msg)
      }
    }).catch((response:any) => {
      this.message(500, response)
    })
  }
  // 登录
  private login() {
    let _this = this;
    (_this.$refs['loginForm'] as Form).validate((valid) => {
      if (valid) {
        _this.buttonData.disabled = true
        _this.buttonData.loadding = true
        _this.buttonData.text = '正在登录'
        request({
          url: '/ClientLogin',
          method: 'POST',
          data: {
            account: _this.loginInfo.account,
            // password: md5(_this.loginInfo.password),
            code: _this.loginInfo.code
          }
        }).then((response:any) => {
          if (response.code === 200 || response.code === 203005) {
            UserModule.Login(response.data.token)
            // var _url = response.code === 200 ? '/dashboard' : '/register/edit'
            var _url = '/dashboard'
            _this.$router.push({
              path: _url
            })
          } else {
            _this.buttonData.disabled = false
            _this.buttonData.loadding = false
            _this.buttonData.text = '登　　录'
            this.loginInfo.code = ''
            // _this.getVerificationCodeImage()
            _this.message(response.code, response.msg)
          }
        }).catch((response:any) => {
          _this.message(500, response)
        })
      } else {
        return false
      }
    })
  }

  private toForget() {
    // this.$router.push({
    //   path: '/register'
    // })
    this.getCodeIdentity(() => {
      this.dialogData.showResetPassWordForm = true
    })
  }
  private toRegister() {
    this.$router.push({
      path: '/register'
    })
  }
  private updatepassword() {
    request({
      url: '/Register/UpdateCheckPhone',
      method: 'POST',
      data: { 
        code: this.passWordInfo.verificationCode, 
        phone: this.passWordInfo.phone
      }
    }).then((response:any) => {
      if (response.code === 200) { // 验证成功
        request({
          url: '/Register/UpdatePassword',
          method: 'GET',
          params: { 
            password: md5(this.passWordInfo.passWord), 
            phone: this.passWordInfo.phone,
            code: this.passWordInfo.verificationCode
          }
        }).then((res:any) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
            this.dialogData.showResetPassWordForm = false
          } else {
            this.$message({
              type: 'warning',
              message: res.msg
            })
          }
        }).catch((res:any) => {
          this.message(500, response)
        })
      } else {
        this.message(response.code, response.msg)
      }
    }).catch((response:any) => {
      this.message(500, response)
    })
  }
  private enter(step) {
    if (step === 1) {
      document.getElementById('password').focus()
    } else if (step === 2) {
      document.getElementById('code').focus()
    } else {
      this.login()
    }
  }

  // 消息
  private message(code, msg) {
    var _code:string = code.toString()
    this.$message({
      message: msg,
      type: code === 200 ? 'success' : _code.indexOf('203') !== -1 ? 'warning' : 'error'
    })
  }
  private dialog(code, msg, callback) {
    this.$message({
      message: msg,
      type: code === 200 ? 'success' : code === 203 ? 'warning' : 'error',
      onClose: callback
    })
  }
  created() {
    // this.getVerificationCodeIdentity(() => {
    //   // this.getVerificationCodeImage()
    // })
  }
}
